const GET_HOT_TOPICS = `query getHotTopics($hotTopicsUid:String!){ categories(
    filters: {
      category_uid: {eq: $hotTopicsUid}
    }
  ){
  items{
    uid
    name
    description
    url_suffix
    url_key
    image
    breadcrumbs{
      category_url_path
      category_name
      }
    children{
      name
      uid
      product_count
      position
      description
      url_path
      url_suffix
      image
    }
  }
  
}}`


const GET_HOT_TOPIC_DETAIL = `query getHotTopicProducts(
  $filter: ProductAttributeFilterInput
) {
  products(filter: $filter) {
    items {
      id
      name
      sku
      url_key
      url_suffix
      hot_topics_description
      categories{ id uid name tags_color}
      short_description { html }
      attribute_set_id

      image{
        url
        label
      }
      thumbnail{
        url
        label
      }
    }
  }
}`

export {GET_HOT_TOPICS, GET_HOT_TOPIC_DETAIL}